// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"513":"6f902ad5ee7399d2","9176":"c237fed8e18d07b5"}[chunkId] + ".js";
};